import { DataTableDefaultCellTemplates, DataTableEventArgs, ITableColumn } from "../../../../components";
import { fomratWithCommasAndDecimals, formatWithCommas } from "../../../../shared/util/currencyUtils";
import { CustomerPolicyDetailLabels as cstPolicyCoverageLabel } from '../../../../shared/util/label';

export default class CustomerFloodCoverageConfig {
    getFloodCoverageTableColumns = (onRowClick: any, onCancelClick: () => void, onRowDeleteClick?: any, tbIndex?: number): ITableColumn[] => {
    
    const commonStartColumns: ITableColumn[] = [
      {
        tabIndex: tbIndex,
        width: '3%',
        maxWidth: '5%',
        cellTemplate: DataTableDefaultCellTemplates.RowExpander.CellTemplate,
        cellClickHandler: async (dtEventArgs: DataTableEventArgs) => {
          const { rowData, dataTableState, eventData } = dtEventArgs;                
          const { rowsState } = dataTableState;
          const rowKey = rowData[dataTableState.dataTable.keyColumnName];
          let currentRowState = rowsState[rowKey];
          
          if (!currentRowState) {
            currentRowState = { expanded: eventData.expand };
          } else {
            currentRowState = { ...currentRowState, expanded: eventData.expand };
          }
          
          if (!currentRowState.expanded && !dataTableState.dataTable.isFormSaved) {
            rowsState[rowKey] = { expanded: true };
            dataTableState.dataTable.setExpandedRowId(rowKey);
              rowsState[rowKey] = { expanded: false };
              dataTableState.dataTable.setExpandedRowId(rowKey);
            }
          
          rowsState[rowKey] = { expanded: currentRowState.expanded };
          
          dataTableState.dataTable.setExpandedRowId(
            currentRowState.expanded ? rowKey : null
          );
          
          if (currentRowState.expanded) {
            onRowClick(rowData, dtEventArgs.column);
          } else {
            onCancelClick();
          }
        },
        cellTdClassName: 'expander-cell-td',
        onKeyDownHandler: (dtEventArgs: DataTableEventArgs) => {
          const { eventData, rowData, dataTableState } = dtEventArgs;
          if (eventData.code === "Enter" || eventData.key === "Enter" || eventData.code === "Space" || eventData.key === " ") {
            if (!eventData.target.classList.contains('chevron-disabled')) {
              const { rowsState } = dataTableState;
              const rowKey = rowData[dataTableState.dataTable.keyColumnName];
              const currentRowState = rowsState[rowKey];
              const expanded = !currentRowState?.expanded;
              
              eventData.expand = expanded;
              
              rowsState[rowKey] = { expanded };
              dataTableState.dataTable.setExpandedRowId(expanded ? rowKey : null);
              
              if (expanded) {
                onRowClick(rowData, dtEventArgs.column);
              } else {
                onCancelClick();
              }
            }
          }
        }
      },
      
      {
        header: cstPolicyCoverageLabel.FLOOD_COVERAGE_BUILDINGLIMIT1,
        field: "buildingLimit1",
        width: "11%",
        cellTdContentClassName: "",
        headerClassName: "",
        cellTemplate: (rowData, column, rowIndex) => (
          <div><span title={rowData.buildingLimit1}>{formatWithCommas(rowData.buildingLimit1)}</span></div>
        )
      },
      {
        header: cstPolicyCoverageLabel.FLOOD_COVERAGE_BUILDINGPREMIUM,
        field: "buildingPremium",
        width: "11%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => (
          <div><span title={rowData.buildingPremium}>{fomratWithCommasAndDecimals(rowData.buildingPremium)}</span></div>
        )
      },
      {
        header: cstPolicyCoverageLabel.FLOOD_COVERAGE_CONTENTLIMIT1,
        field: "contentLimit1",
        width: "11%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => (
          <div><span title={rowData.contentLimit1}>{formatWithCommas(rowData.contentLimit1)}</span></div>
        )
      },
      {
        header: cstPolicyCoverageLabel.FLOOD_COVERAGE_CONTENTPREMIUM,
        field: "contentPremium",
        width: "11%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => (
          <div><span title={rowData.contentPremium}>{fomratWithCommasAndDecimals(rowData.contentPremium)}</span></div>
        )
      },      
      {
        header: cstPolicyCoverageLabel.FLOOD_COVERAGE_ADDITIONALCOVERAGETOTAL,
        field: "additionalCoverageTotal",
        width: "14%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => (
          <div><span title={rowData.additionalCoverageTotal}>{fomratWithCommasAndDecimals(rowData.additionalCoverageTotal)}</span></div>
        )
      },
      {
        header: cstPolicyCoverageLabel.FLOOD_COVERAGE_DISCOUNTSURCHARGESTOTAL,
        field: "discountSurchargesTotal",
        width: "14%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => (
          <div><span title={rowData.discountSurchargesTotal}>{fomratWithCommasAndDecimals(rowData.discountSurchargesTotal)}</span></div>
        )
      },
      {
        header: cstPolicyCoverageLabel.FLOOD_COVERAGE_PREPAIDTOTAL,
        field: "prePaidTotal",
        width:  "11%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => (          
          <div><span title={rowData.prePaidTotal}>{fomratWithCommasAndDecimals(rowData.prePaidTotal)}</span></div>
        )
      },
      {
        header: cstPolicyCoverageLabel.FLOOD_COVERAGE_ANNUALTOTAL,
        field: "annualTotal",
        width:  "11%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => (
          <div><span title={rowData.annualTotal}>{fomratWithCommasAndDecimals(rowData.annualTotal)}</span></div>
        )
      }
    ];

    
    const commonEndColumns: ITableColumn[] = [      
      {
        tabIndex: tbIndex,
        width : '5em',
        maxWidth : '5em', 
        cellTemplate : DataTableDefaultCellTemplates.DeleteCellTemplate.CellTemplate,
        cellClickHandler : (dtEventArgs : DataTableEventArgs) => onRowDeleteClick(dtEventArgs.rowData, dtEventArgs.column),
        onKeyDownHandler: (dtEventArgs: DataTableEventArgs) => {
          const { eventData } = dtEventArgs;
          if (eventData.code === "Enter" || eventData.key === "Enter" || eventData.code === "Space" || eventData.key === " ") {
            onRowDeleteClick(dtEventArgs.rowData, dtEventArgs.column);
          }
        }
      }
    ];

      return [
      ...commonStartColumns,
      ...commonEndColumns
    ];
  }
}